import React from 'react';
import { getUUID } from '../../utils/utilities';
const ShopifyResponsiveImage = ({ imageSrc, imageAlt, aspectRatio, classNames, }) => {
    const UUID = getUUID();
    if (!imageSrc) {
        return null;
    }
    const source = imageSrc.replace('_300x', '_{width}x');
    return (React.createElement("img", { key: UUID + imageSrc, className: `lazyload ${classNames}`, src: imageSrc, "data-src": source, "data-widths": "[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]", "data-aspectratio": aspectRatio, "data-sizes": "auto", alt: imageAlt }));
};
export default ShopifyResponsiveImage;
